var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "material-design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M16,1c3.8,0,7.3,1.4,10,3.8H6C8.8,2.3,12.3,1,16,1L16,1z  M6.4,5.8h19.2L16,25L6.4,5.8z M4.8,6V26C2.3,23.2,1,19.7,1,16C1,12.2,2.4,8.7,4.8,6L4.8,6z M27.2,6c2.5,2.7,3.8,6.3,3.8,10 c0,3.8-1.4,7.3-3.8,10V6z M5.8,6.8l9.7,19.4H5.8V6.8z M26.2,6.8v19.4h-9.7L26.2,6.8L26.2,6.8z M6,27.2H26c-2.7,2.5-6.3,3.8-10,3.8 S8.8,29.7,6,27.2L6,27.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.714a0acd6d7c9747e850932ed00d67a5.svg";
export { ForwardRef as ReactComponent };